import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

type UseEditAnnotationMutationVariables = {
  annotationId: string;
  message: string;
};

export const useEditAnnotationMutation = () => {
  const { authApi } = useAuth();
  const queryClient = useQueryClient();
  const result = useMutation({
    mutationFn: async ({
      annotationId,
      ...payload
    }: UseEditAnnotationMutationVariables) => {
      const { data } = await authApi.patch(
        `/virtual-tour/annotation/${annotationId}`,
        payload
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["virtual-tour-annotations"],
      });
    },
  });

  return result;
};
